interface PluraliserOptions {
  none: string;
  singular: string;
  plural: string;
}

export const pluraliser = (
  count: number,
  { none, singular, plural }: PluraliserOptions
): string => {
  if (count === 0) {
    return none;
  }

  if (count === 1) {
    return singular;
  }

  return plural;
};
